import Content from '../../content.js';
import Events from '../../../util/eventEmitter';

namespace('IO.Views.Users.ShellUser', function (exports) {
  'use strict';

  var New = Content.extend({
    dom: {
      SHELL_ACCOUNT_CONTAINER: '.shell-account-container',
      SHELL_ACCOUNT_FORM: '.shell-account-container form',
      EDIT_SHELL_ACCOUNT: '#edit-shell-account',
    },

    events: function () {
      var events = {};

      events['submit ' + this.dom.SHELL_ACCOUNT_FORM] = '_submitShellAccount';
      return events;
    },

    render: function () {
      if (location.hash === '#send_alert') {
        location.hash = '';
      }
    },

    reload: function (callback) {
      this.callback = callback;
    },

    _submitShellAccount: function (e) {
      var $form = $(e.currentTarget),
        self = this;

      e.preventDefault();
      e.stopPropagation(); // avoid pjax

      $.post($form.prop('action'), $form.serialize())
        .done(function () {
          location.href = '#send_alert';
        })
        .fail(function (xhr, textStatus) {
          var $data = $(xhr.responseText);

          Events.emit('showErrorMessage', xhr, textStatus);
          self._setSaveState($data);
          self._attachToShellAccounContainer(
            $data.find(self.dom.EDIT_SHELL_ACCOUNT),
          );
        });
    },

    _attachToShellAccounContainer: function (data) {
      $(this.dom.SHELL_ACCOUNT_CONTAINER).html(data);
      if (this.callback) {
        this.callback();
      }
    },

    _setSaveState: function (data) {
      data.find('.io-form-action-save').show();
      data.find('.io-form-action-edit').hide();
    },
  });

  exports.New = New;
});
